import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { SesionService } from './sesion.service';
import { UtilsService } from './utils.service';
import { AppConstants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ResolverloginService implements Resolve<any> {
  constructor(private sesionService: SesionService, private utilsService: UtilsService) { }

  resolve(route: ActivatedRouteSnapshot) {
    if (this.sesionService.validarSesion()) {
      this.utilsService.redirectPathWindow(AppConstants.APLICATION_MODULES.INICIO.ruta);
    } else {
      return;
    }
  }

}
